<template>
  <ion-page>
    <ion-header>
      <div class="navbar">
        <img class="nav-icon" :src="getBrandImageUrl('xiaoyu.png')" alt="" @click="onClose" />
        收藏夹
      </div>
      <!-- <ion-toolbar class="topbar">
        <ion-title>阅读理解收藏词汇</ion-title>
        <ion-buttons slot="start">
          <ion-icon :icon="chevronBackOutline" @click="onClose" fill="clear" color="Medium"></ion-icon>
        </ion-buttons>
      </ion-toolbar> -->
    </ion-header>
    <ion-content>
      <ion-refresher slot="fixed" @ionRefresh="doRefresh($event)">
        <ion-refresher-content
          pulling-text="Pull to refresh"
          refreshing-spinner="circles"
          refreshing-text="Refreshing..."
        >
        </ion-refresher-content>
      </ion-refresher>
      <div style="height: 11px"></div>
      <div
        v-for="(item, index) in dataList"
        :key="index"
        class="content-box"
        @click="playSound(item.word)"
      >
        <div>
          <span class="label">{{ index + 1 }}.</span>
          <span class="label2" style="margin-right: 10px">{{ item.word }}</span>
          <span class="label3">{{ item.paraphrase }}</span>
        </div>
        <img
          class="pic"
          :src="getBrandImageUrl('my_words1.png')"
          alt=""
          @click.stop="onDelete(item.id, $event)"
        />
      </div>
      <div v-if="show" class="box">
        <img :src="getBrandImageUrl('my_words2.png')" alt="" />
        <div>取消收藏成功</div>
      </div>

      <!-- <ion-list>
        <ion-item>
          <ion-row style="width: 100%;">
            <ion-col size="2">
              <ion-label>序号</ion-label>
            </ion-col>
            <ion-col size="4">
              <ion-label>单词</ion-label>
            </ion-col>
            <ion-col class="item-right" size="6">
              <span>释义</span>
            </ion-col>
          </ion-row>
        </ion-item>
        <ion-item-sliding v-for="(item, index) in dataList" :key="index">
          <ion-item>
            <ion-row style="width: 100%;">
              <ion-col size="2">
                <ion-label>{{ index + 1 }}</ion-label>
              </ion-col>
              <ion-col size="4">
                <ion-label>{{ item.word }}</ion-label>
              </ion-col>
              <ion-col class="item-right" size="6">
                {{ item.paraphrase }}
              </ion-col>
            </ion-row>
          </ion-item>
          <ion-item-options side="end">
            <ion-item-option color="tertiary" @click="onDelete(item.id,$event)">
              删除
            </ion-item-option>
          </ion-item-options>
        </ion-item-sliding>
      </ion-list> -->
      <ion-infinite-scroll
        id="infinite-scroll"
        threshold="100px"
        :disabled="isDisabled"
        @ionInfinite="loadData($event)"
      >
        <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="数据加载中...">
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ion-content>
  </ion-page>
</template>
<script>
import {
  IonPage,
  IonHeader,
  IonContent,
  modalController,
  IonRefresher,
  IonRefresherContent,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
} from "@ionic/vue";
import { getBrandImageUrl } from "@/js/brandImages";
import { chevronBackOutline } from "ionicons/icons";

export default {
  name: "ReadingPersonalVocabulary",
  components: {
    IonPage,
    IonHeader,
    IonContent,
    IonRefresher,
    IonRefresherContent,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
  },
  props: ["studentId"],
  setup() {
    return {
      chevronBackOutline,
    };
  },

  data() {
    return {
      dataObject: {},
      dataList: [],
      currentPage: 1,
      isDisabled: false,
      queryForm: {
        pageNum: 1,
        pageSize: 50,
      },
      show: false,
    };
  },

  mounted() {
    this.userinfo = this.store.getUser();
    this.queryReadingPersonalVocabulary();
  },

  methods: {
    getBrandImageUrl,
    onClose() {
      modalController.dismiss();
    },

    //查询需要练习的词汇
    queryReadingPersonalVocabulary() {
      this.queryForm.pageNum = this.currentPage;
      const appointment = this.store.getAppointment();
      this.queryForm.studentId = appointment.studentId;
      this.ajax
        .post("/readingVocabulary/queryReadingPersonalVocabulary", this.queryForm)
        .then((res) => {
          if (res.data.success) {
            if (res.data && res.data.page && res.data.page.list) {
              res.data.page.list.forEach((item) => {
                this.dataList.push(item);
              });
            }
            this.currentPage++;
          }
        });
    },

    doRefresh(ev) {
      if (ev) {
        ev.target.complete();
      }
      this.currentPage = 1;
      this.dataList = [];
      this.queryReadingPersonalVocabulary();
    },

    loadData(ev) {
      this.queryReadingPersonalVocabulary();
      ev.target.complete();
    },

    onDelete(id, event) {
      this.ajax.get("/vocabulary/deleteVocabularyPersonal?id=" + id).then((res) => {
        if (res.data.success) {
          this.closeSliding(event);
          const arr = [];
          this.dataList.forEach(function (item) {
            if (item.id != id) {
              arr.push(item);
            }
          });
          this.dataList = arr;
          this.show = true;
          setTimeout(() => {
            this.show = false;
          }, 1000);
        }
      });
    },
  },
};
</script>

<style scoped>
/* new ui  */
.navbar {
  height: 44px;
  line-height: 44px;
  text-align: center;
  position: relative;
  font-size: 17px;
  font-weight: 500;
}
.nav-icon {
  width: 24px;
  height: 24px;
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translate(0, -50%);
}
ion-header::after {
  display: none;
}
ion-header {
  background: #fff;
}
ion-content {
  --background: #fff;
}
.content-box {
  width: 92vw;
  height: 54px;
  margin: 0 auto 15px;
  background: #f8f8f8;
  border-radius: 6px;
  padding: 0 10px 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;
}
.pic {
  width: 22px;
  height: 22px;
}
.label {
  color: #606266;
  font-size: 15px;
}
.label2 {
  color: #262626;
  font-size: 15px;
}
.label3 {
  color: #868f9e;
  font-size: 15px;
}
.box {
  position: fixed;
  width: 33.07vw;
  height: 33.07vw;
  border-radius: 10px;
  background-color: rgba(110, 110, 110);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding-top: 4.67vw;
}
.box img {
  width: 15.73vw;
  height: 15.73vw;
  display: block;
  margin: 0 auto 2.67vw;
}
.box div {
  color: #fff;
  text-align: center;
  font-size: 3.73vw;
}
</style>
